import { Layout as AntLayout } from "antd";
// import { useEffect } from "react";
import AppSidebar from "@/components/AppSidebar";
// import SessionExpiringModal from "@/components/SessionExpiringModal";
// import { useAuth } from "@/contexts/auth";
// import { useSession } from "@/hooks";
import HeaderPage from "../Header/Header";

const { Content } = AntLayout;

export default function AppLayout({ children }: { children: React.ReactNode }) {
  // Layout no longer handles initialization
  // Initialization is now handled after successful login

  // TODO: Session feature temporarily disabled - will be enabled later
  // const { user } = useAuth();
  // const {
  //   showExpiringModal,
  //   sessionExpiringData,
  //   isInitializing: isSessionRenewing,
  //   renewSession,
  //   dismissExpiringModal,
  //   initializeSession,
  // } = useSession();

  // Initialize session when user is authenticated
  // useEffect(() => {
  //   if (user) {
  //     // Initialize session after user login
  //     initializeSession().catch((error) => {
  //       console.error("Failed to initialize session:", error);
  //     });
  //   }
  // }, [user, initializeSession]);

  return (
    <AntLayout>
      <AppSidebar />
      <AntLayout>
        <Content className="bg-[#f0f2f6] ">
          <HeaderPage />
          <main className="layout-container w-full min-h-screen flex flex-col">
            <div id="page-layout" className="relative p-0 md:p-4 flex-1 flex flex-col">
              {children}
            </div>
          </main>
        </Content>
      </AntLayout>

      {/* TODO: Session expiring warning modal - temporarily disabled */}
      {/* <SessionExpiringModal
        visible={showExpiringModal}
        sessionExpiringData={sessionExpiringData}
        isRenewing={isSessionRenewing}
        onRenew={renewSession}
        onDismiss={dismissExpiringModal}
      /> */}
    </AntLayout>
  );
}
